import {
  Document,
  Font,
  Page,
  StyleSheet,
  Text,
  View,
  Image,
} from "@react-pdf/renderer";
import moment from "moment";
import iBMPlexRegularFont from "../../../fonts/IBMPlexSansArabic-Regular.ttf";

const PreauthorizationPrintOCAF = ({ printData, row }) => {
  const selectedBranch = JSON.parse(localStorage.getItem("selectedBranch"));

  const isChecked = (key) =>
    printData?.other_fields?.vision_extraflds?.lens_specifications?.includes(
      key.toLowerCase(),
    );

  const type = printData?.provider_request?.opticals?.[0]?.type;

  const visitTypes = [
    { label: "New visit", code: "new-visit" },
    { label: "Follow Up", code: "follow-up" },
    { label: "Refill", code: "refill" },
    { label: "Walk In", code: "walkin" },
    { label: "Referral", code: "referral" },
  ];
  const OpticalPrescriptionCard = ({ type }) => {
    const visionPrescription = printData?.provider_request?.opticals;

    const getEyeData = (eye, usage) => {
      return visionPrescription?.find(
        (spec) =>
          spec.eye === eye.toLowerCase() &&
          spec.notes?.[0]?.text === usage.toLowerCase(),
      );
    };

    const renderEyeSection = (eyeLabel) => {
      const distanceData = getEyeData(eyeLabel, "distance");
      const nearData = getEyeData(eyeLabel, "near");

      // Helper to get prism value by base
      const getPrism = (data, base) =>
        data?.prism?.find((p) => p.base === base.toLowerCase())?.amount || "";
      return (
        <View style={styles.card}>
          {/* Eye Title Row */}
          <View style={[styles.gridContainer, styles.tableRow]}>
            <View style={{ width: "15%" }}></View>
            <View style={[styles.cell, styles.roundedBorder, { flex: 9.4 }]}>
              <Text style={styles.s1textValue}>
                {eyeLabel.toUpperCase()} EYE
              </Text>
            </View>
          </View>

          {/* Header Row */}
          {type === "lens" ? (
            <View style={[styles.gridContainer, styles.tableRow]}>
              <View style={{ width: "15%" }}></View>
              <View
                style={[
                  styles.cell,
                  { flex: 1.2, borderLeft: "0.7px solid #999" },
                ]}
              >
                <Text>Sphere</Text>
              </View>
              <View style={[styles.cell, { flex: 1.2 }]}>
                <Text>Cylinder</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>Axis</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>In</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>Out</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>Up</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>Down</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>Brand</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>Color</Text>
              </View>
            </View>
          ) : (
            <View style={[styles.gridContainer, styles.tableRow]}>
              <View style={{ width: "15%" }}></View>
              <View
                style={[
                  styles.cell,
                  { flex: 1.2, borderLeft: "0.7px solid #999" },
                ]}
              >
                <Text>Power</Text>
              </View>
              <View style={[styles.cell, { flex: 1.2 }]}>
                <Text>Cylinder</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>Axis</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>BackCurve</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>diameter</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>Add</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>Color</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>Brand</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>Duration</Text>
              </View>
            </View>
          )}

          {/* Distance Row */}
          {type === "lens" ? (
            <View style={[styles.gridContainer, styles.tableRow]}>
              <View
                style={[
                  styles.cell,
                  {
                    width: "15%",
                    borderTop: "0.7px solid #999",
                    borderLeft: "0.7px solid #999",
                  },
                ]}
              >
                <Text>Distance</Text>
              </View>
              <View style={[styles.cell, { flex: 1.2 }]}>
                <Text>{distanceData?.sphere || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.2 }]}>
                <Text>{distanceData?.cylinder || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{distanceData?.axis || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{getPrism(distanceData, "in")}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{getPrism(distanceData, "out")}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{getPrism(distanceData, "up")}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{getPrism(distanceData, "down")}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>{distanceData?.brand || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>{distanceData?.color || ""}</Text>
              </View>
            </View>
          ) : (
            <View style={[styles.gridContainer, styles.tableRow]}>
              <View
                style={[
                  styles.cell,
                  {
                    width: "15%",
                    borderTop: "0.7px solid #999",
                    borderLeft: "0.7px solid #999",
                  },
                ]}
              >
                <Text>Distance</Text>
              </View>
              <View style={[styles.cell, { flex: 1.2 }]}>
                <Text>{distanceData?.power || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.2 }]}>
                <Text>{distanceData?.cylinder || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{distanceData?.axis || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{distanceData?.backcurve || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{distanceData?.diameter || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{distanceData?.add}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{distanceData?.color}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>{distanceData?.brand || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>{distanceData?.duration || ""}</Text>
              </View>
            </View>
          )}

          {/* Near Row */}
          {type === "lens" ? (
            <View style={[styles.gridContainer, styles.tableRow]}>
              <View
                style={[
                  styles.cell,
                  { width: "15%", borderLeft: "0.7px solid #999" },
                ]}
              >
                <Text>Near</Text>
              </View>
              <View style={[styles.cell, { flex: 1.2 }]}>
                <Text>{nearData?.sphere || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.2 }]}>
                <Text>{nearData?.cylinder || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{nearData?.axis || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{getPrism(nearData, "in")}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{getPrism(nearData, "out")}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{getPrism(nearData, "up")}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{getPrism(nearData, "down")}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>{nearData?.brand || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>{nearData?.color || ""}</Text>
              </View>
            </View>
          ) : (
            <View style={[styles.gridContainer, styles.tableRow]}>
              <View
                style={[
                  styles.cell,
                  { width: "15%", borderLeft: "0.7px solid #999" },
                ]}
              >
                <Text>Near</Text>
              </View>
              <View style={[styles.cell, { flex: 1.2 }]}>
                <Text>{nearData?.power || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.2 }]}>
                <Text>{nearData?.cylinder || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{nearData?.axis || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{nearData?.backcurve || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{nearData?.diameter || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{nearData?.add}</Text>
              </View>
              <View style={[styles.cell, { flex: 0.8 }]}>
                <Text>{nearData?.color}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>{nearData?.brand || ""}</Text>
              </View>
              <View style={[styles.cell, { flex: 1.5 }]}>
                <Text>{nearData?.duration || ""}</Text>
              </View>
            </View>
          )}
        </View>
      );
    };

    return (
      <View style={styles.card}>
        <Text style={styles.title}>To be Completed by the Optician</Text>
        {renderEyeSection("Right")}
        {renderEyeSection("Left")}
      </View>
    );
  };

  const patientInformation = printData?.provider_request?.patient;
  const preauthResponse = printData?.payer_response;
  const selectedType = printData?.provider_request?.visitreasons;

  const days = preauthResponse?.preauthto
    ? moment(preauthResponse.preauthto, "YYYY-MM-DD").diff(
        moment(preauthResponse.preauthfrom, "YYYY-MM-DD"),
        "days",
      ) + 1
    : 0;

  const preauthServicesRequest =
    printData?.provider_request?.service_procedures;
  const preauthServiceResponse = printData?.service_procedures;
  return (
    <Document>
      <Page size="A3" style={styles.page}>
        <Text style={styles.heading}>ocaf 2.0</Text>
        <View style={styles.flexRow}>
          <View style={styles.cardStyle}>
            <Text style={styles.title}>
              To be completed & ID verified by the reception/nurse:
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Provider Name: </Text>
              <Text style={styles.s1textvalue}>
                {selectedBranch?.branch_name || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Insurance Company Name: </Text>
              <Text style={styles.s1textvalue}>
                {printData?.insurance || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>TPA Company Name: </Text>
              <Text style={styles.s1textvalue}>{row?.payer_name}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Patient File Number: </Text>
              <Text style={styles.s1textvalue}>
                {patientInformation?.mrn || ""}
              </Text>
            </Text>
            <View style={styles.flexRow}>
              <Text style={styles.checkItem}>
                Single {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Married {"(  "}
                {")"}
              </Text>
              <Text style={styles.checkItem}>
                Plan Type {"(  "}
                {")"}
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date of visit: </Text>
              <Text style={styles.s1textvalue}>
                {printData?.provider_request?.req_time
                  ? moment(printData?.provider_request?.req_time).format(
                      "DD-MM-YYYY hh:mm:ss A",
                    )
                  : ""}
              </Text>
            </Text>
            {/* Visit Types Section */}
            <View style={styles.flexRow}>
              {visitTypes.map((item, index) => {
                // Normalize comparison
                const normalize = (str) => str?.toLowerCase().replace(/-/g, "");
                const isSelected =
                  normalize(selectedType) === normalize(item.code);

                return (
                  <Text key={index} style={styles.checkItem}>
                    {item.label} {"("} {`${isSelected ? `✓` : ""}`}
                    {")"}
                  </Text>
                );
              })}
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval Date/Time : </Text>
              <Text style={styles.s1textvalue}>
                {preauthResponse?.response_datetime
                  ? moment(preauthResponse?.response_datetime).format(
                      "DD-MM-YYYY hh:mm:ss A",
                    )
                  : ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval Validity : </Text>
              <Text style={styles.s1textvalue}>{days} days</Text>
            </Text>
          </View>
          <View style={styles.cardStyle}>
            <Text style={styles.title}>
              Print/Fill in clear letters or Emboss Card:
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Insured name: </Text>
              <Text style={styles.s1textvalue}>
                {printData?.provider_request?.patient?.name || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>National ID / Iqama : </Text>
              <Text style={styles.s1textvalue}>
                {patientInformation?.nationalid || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>ID. Card No. : </Text>
              <Text style={styles.s1textvalue}>
                {patientInformation?.memberid}
              </Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Sex : </Text>
                <Text
                  style={[styles.s1textvalue, { textTransform: "capitalize" }]}
                >
                  {patientInformation?.gender}
                </Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>DOB : </Text>
                <Text style={styles.s1textvalue}>
                  {patientInformation?.birthdate
                    ? moment(patientInformation?.birthdate).format("DD-MM-YYYY")
                    : ""}
                </Text>
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Policy Holder : </Text>
              <Text style={styles.s1textvalue}>
                {patientInformation?.polycyname || ""}
              </Text>
            </Text>

            <View style={[styles.flexRow]}>
              <Text style={[styles.dottedLine, { flex: 1, width: "auto" }]}>
                <Text style={styles.s1textLabel}>Policy No. : </Text>
                <Text style={styles.s1textvalue}>
                  {patientInformation?.polycyno || ""}
                </Text>
              </Text>
              <Text style={[styles.dottedLine, { flex: 1.2, width: "auto" }]}>
                <Text style={styles.s1textLabel}>
                  Approval Expiry Date :{" "}
                </Text>
                <Text style={styles.s1textvalue}>
                  {printData?.payer_response?.preauthto
                    ? moment(printData?.payer_response?.preauthto).format(
                        "DD-MM-YYYY",
                      )
                    : ""}
                </Text>
              </Text>
              <Text style={[styles.dottedLine, { flex: 0.8, width: "auto" }]}>
                <Text style={styles.s1textLabel}>Class : </Text>
                <Text style={styles.s1textvalue}>
                  {patientInformation?.class || ""}
                </Text>
              </Text>
            </View>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                {preauthResponse?.preauth_status} Reference Number :{" "}
              </Text>
              <Text style={styles.s1textvalue}>
                {preauthResponse?.preauth_ref || ""}
              </Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Approval Status : </Text>
                <Text style={styles.s1textvalue}>
                  {preauthResponse?.preauth_status || ""}
                </Text>
              </Text>
            </View>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Approval Type : </Text>
                <Text style={styles.s1textvalue}>
                  {preauthResponse?.claim_typenme?.toLowerCase() === "oral"
                    ? "Dental"
                    : preauthResponse?.claim_typenme || ""}
                </Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Approval Sub Type : </Text>
                <Text style={styles.s1textvalue}>
                  {preauthResponse?.preauth_subtype || ""}
                </Text>
              </Text>
            </View>
          </View>
        </View>
        <OpticalPrescriptionCard type={type} />
        {/* </View> */}
        <View style={[styles.flexRow, { marginTop: 5 }]}>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Regular Lenses Type: </Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Glass: </Text>
            <Text style={styles.s1textvalue}>
              ({" "}
              {printData?.other_fields?.vision_extraflds?.regular_lenses ===
              "glass"
                ? "✓"
                : " "}
              )
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Plastic: </Text>
            <Text style={styles.s1textvalue}>
              ({" "}
              {printData?.other_fields?.vision_extraflds?.regular_lenses ===
              "plastic"
                ? "✓"
                : " "}
              )
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>None: </Text>
            <Text style={styles.s1textvalue}>
              ({" "}
              {!printData?.other_fields?.vision_extraflds?.regular_lenses
                ? "✓"
                : " "}
              )
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}> </Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
        </View>
        <View style={[styles.flexRow, { marginTop: 5 }]}>
          <Text style={styles.dottedLine}>
            <Text style={[styles.s1textLabel, { marginRight: "16px" }]}>
              Lenses Specification:
            </Text>
            <Text style={styles.s1textvalue}>{"  "}</Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Multi-coated: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("multicoated") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Medium: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("medium") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Anti-reflecting coating: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("antireflectingcoating") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Varilux: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("varilux") ? "✓" : " "})
            </Text>
          </Text>
        </View>

        <View style={[styles.flexRow, { marginTop: 5 }]}>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}> </Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Lenticular: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("lenticular") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Photosensitive: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("photosensitive") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Light: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("light") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Single Version: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("singlevision") ? "✓" : " "})
            </Text>
          </Text>
        </View>
        <View style={[styles.flexRow, { marginTop: 5 }]}>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}> </Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>

          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>High Index: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("high index") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Aspheric: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("aspheric") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Dark: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("dark") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Colored: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("colored") ? "✓" : " "})
            </Text>
          </Text>
        </View>
        <View style={[styles.flexRow, { marginTop: 5 }]}>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}> </Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Bifocal: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("bifocal") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Safety Thickness: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("safetythickness") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Anti-Scratch: </Text>
            <Text style={styles.s1textvalue}>
              ({isChecked("antiscratch") ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}> </Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
        </View>
        <View style={[styles.flexRow, { marginTop: 5 }]}>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}> Contact Lenses Type: </Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Permanent: </Text>
            <Text style={styles.s1textvalue}>
              {" "}
              ({" "}
              {printData?.other_fields?.vision_extraflds?.regular_contact ==
              "permanent"
                ? "✓"
                : ""}
              )
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Disposal: </Text>
            <Text style={styles.s1textvalue}>
              {" "}
              ({" "}
              {printData?.other_fields?.vision_extraflds?.regular_contact ==
              "disposable"
                ? "✓"
                : ""}
              )
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>{"  "}</Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>{"  "}</Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
        </View>
        <View style={[styles.flexRow, { marginTop: 5 }]}>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}> Frames: </Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>Yes: </Text>
            <Text style={styles.s1textvalue}>
              ( {printData?.other_fields?.vision_extraflds?.isframe ? "✓" : " "}
              )
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}>No: </Text>
            <Text style={styles.s1textvalue}>
              ({" "}
              {!printData?.other_fields?.vision_extraflds?.isframe ? "✓" : " "})
            </Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}> </Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
          <Text style={styles.dottedLine}>
            <Text style={styles.s1textLabel}> </Text>
            <Text style={styles.s1textvalue}> {"  "}</Text>
          </Text>
        </View>
        <View style={[styles.card]}>
          <View style={styles.table}>
            {/* Table Header */}
            <View style={styles.tableRow}>
              <Text style={[styles.tableCellSer, styles.descriptionCellSer]}>
                (Code) Service
              </Text>
              <Text style={styles.tableCellSer}>Type</Text>
              <Text style={styles.tableCellSer}>Req Qty</Text>
              <Text style={styles.tableCellSer}>Unit Price</Text>
              <Text style={styles.tableCellSer}>Gross</Text>
              <Text style={styles.tableCellSer}>App Qty</Text>
              <Text style={styles.tableCellSer}>App Cost</Text>
              <Text style={[styles.tableCellSer, styles.lastTableCellSer]}>
                Note
              </Text>
            </View>

            {/* Table Rows */}
            {preauthServicesRequest?.filter(
              (item) => item?.prdtypcde == "itm_prdt",
            )?.length > 0 ? (
              preauthServicesRequest
                ?.filter((item) => item?.prdtypcde == "itm_prdt")
                ?.map((item, index, array) => {
                  const isLast = index === array.length - 1;

                  const toothNo = item?.toothno;

                  // Calculations
                  const quantity = parseFloat(item?.servinfo_prdqty) || 0;
                  const unitPrice = parseFloat(item?.servinfo_prdpri) || 0;
                  const gross = (quantity * unitPrice).toFixed(2);

                  const approvedService = preauthServiceResponse?.[index];
                  const approvedQty = parseFloat(item?.apprv_qty) || 0;
                  const grossApproved = (approvedQty * unitPrice).toFixed(2);
                  return (
                    <View style={[styles.tableRow, ,]} key={index}>
                      <Text
                        style={[
                          styles.tableCellSer,
                          styles.descriptionCellSer,
                          isLast && { borderBottom: "1px solid #999" },
                        ]}
                      >
                        {item?.itemcode && `(${item.itemcode}) `}
                        {item?.itemdescp}
                        {item?.itemlclcode && ` (${item?.itemlclcode})`}
                        {item?.itemlcldescp}
                      </Text>

                      <Text
                        style={[
                          styles.tableCellSer,
                          isLast && { borderBottom: "1px solid #999" },
                        ]}
                      >
                        Procedures
                      </Text>
                      <Text
                        style={[
                          styles.tableCellSer,
                          isLast && { borderBottom: "1px solid #999" },
                        ]}
                      >
                        {quantity}
                      </Text>
                      <Text
                        style={[
                          styles.tableCellSer,
                          isLast && { borderBottom: "1px solid #999" },
                        ]}
                      >
                        {unitPrice.toFixed(2)}
                      </Text>
                      <Text
                        style={[
                          styles.tableCellSer,
                          isLast && { borderBottom: "1px solid #999" },
                        ]}
                      >
                        {gross}
                      </Text>
                      <Text
                        style={[
                          styles.tableCellSer,
                          isLast && { borderBottom: "1px solid #999" },
                        ]}
                      >
                        {approvedService?.apprv_qty || "0"}
                      </Text>
                      <Text
                        style={[
                          styles.tableCellSer,
                          isLast && { borderBottom: "1px solid #999" },
                        ]}
                      >
                        {grossApproved || "0.00"}
                      </Text>
                      <Text
                        style={[
                          styles.tableCellSer,
                          isLast && { borderBottom: "1px solid #999" },
                          styles.lastTableCellSer,
                        ]}
                      >
                        {approvedService?.serv_status || ""}
                      </Text>
                    </View>
                  );
                })
            ) : (
              <View style={styles.tableRow}>
                <Text style={[styles.tableCellSer, styles.noDataCell]}>
                  No Data To Show
                </Text>
              </View>
            )}
          </View>
          <View style={[styles.flexRow]}>
            <Text style={[styles.s1textLabel, styles.text, styles.mt3]}>
              Providers Approval/Coding Staff must review/code the recommended
              service(s) and allocate cost and complete the following:
            </Text>
          </View>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Completed / Coded By: </Text>
              <Text style={styles.s1textvalue}> {"."?.repeat(30)}</Text>
            </Text>

            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Signature: </Text>
              <Text style={styles.s1textvalue}> {"."?.repeat(30)}</Text>
            </Text>

            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date: </Text>
              <Text style={styles.s1textvalue}>
                {" "}
                {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
              </Text>
            </Text>
          </View>
          <View style={styles.section}>
            <View style={styles.table}>
              {/* Table Header */}
              <View style={styles.tableRow}>
                <Text style={[styles.tableCellSer, styles.descriptionCellSer]}>
                  Medication Name (Generic Name)
                </Text>
                <Text style={styles.tableCellSer}>Type</Text>
                <Text style={styles.tableCellSer}>Req Qty</Text>
                <Text style={styles.tableCellSer}>Req Cost</Text>
                <Text style={styles.tableCellSer}>Gross</Text>
                <Text style={styles.tableCellSer}>App Qty</Text>
                <Text style={styles.tableCellSer}>App Cost</Text>
                <Text style={[styles.tableCellSer, styles.lastTableCellSer]}>
                  Note
                </Text>
              </View>

              {/* Table Rows */}
              {preauthServicesRequest?.filter(
                (item) => item?.prdtypcde != "itm_prdt",
              )?.length > 0 ? (
                preauthServicesRequest
                  ?.filter((item) => item?.prdtypcde != "itm_prdt")
                  ?.map((item, index, array) => {
                    const isLast = index === array.length - 1;

                    const toothNo = item?.tooth_no;

                    // Calculations
                    const quantity = parseFloat(item?.servinfo_prdqty) || 0;
                    const unitPrice = parseFloat(item?.servinfo_prdpri) || 0;
                    const gross = (quantity * unitPrice).toFixed(2);

                    const approvedService = preauthServiceResponse?.[index];
                    const approvedQty = parseFloat(item?.apprv_qty) || 0;
                    const grossApproved = (approvedQty * unitPrice).toFixed(2);
                    return (
                      <View style={[styles.tableRow, ,]} key={index}>
                        <Text
                          style={[
                            styles.tableCellSer,
                            styles.descriptionCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {item?.itemcode && `(${item.itemcode}) `}
                          {item?.itemdescp}
                          {item?.itemlclcode && ` (${item?.itemlclcode})`}
                          {item?.itemlcldescp}
                        </Text>

                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          Medication
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {quantity}
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {unitPrice.toFixed(2)}
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {gross}
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {approvedService?.apprv_qty || "0"}
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                          ]}
                        >
                          {grossApproved || "0.00"}
                        </Text>
                        <Text
                          style={[
                            styles.tableCellSer,
                            isLast && { borderBottom: "1px solid #999" },
                            styles.lastTableCellSer,
                          ]}
                        >
                          {approvedService?.serv_status || ""}
                        </Text>
                      </View>
                    );
                  })
              ) : (
                <View style={styles.tableRow}>
                  <Text style={[styles.tableCellSer, styles.noDataCell]}>
                    No Data To Show
                  </Text>
                </View>
              )}
            </View>
          </View>
        </View>
        <View style={[styles.flexRow]}>
          <View style={styles.cardStyle}>
            <Text style={styles.s1textvalue}>
              I hereby certify that ALL information mentioned are correct and
              that the medical services shown on this form were medically
              indicated and necessary for the management of this case.
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Physician: </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(70)}</Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature: </Text>
                <Text style={styles.s1textvalue}>{"."?.repeat(40)}</Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
          </View>
          <View style={styles.cardStyle}>
            <Text style={styles.s1textvalue}>
              I hereby certify that ALL statements and information provided
              concerning patient identification and the present illness or
              injury are TRUE.
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Name (and relationship if guardian):{" "}
              </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(50)}</Text>
            </Text>
            <View style={[styles.flexRow]}>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Signature(*) </Text>
                <Text style={styles.s1textvalue}></Text>
              </Text>
              <Text style={styles.dottedLine}>
                <Text style={styles.s1textLabel}>Date: </Text>
                <Text style={styles.s1textvalue}>
                  {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
                </Text>
              </Text>
            </View>
          </View>
        </View>
        <View style={styles.card}>
          <View style={[styles.flexRow]}>
            <Text style={styles.dottedLine}>
              <Text style={[styles.s1textLabel, { marginRight: "16px" }]}>
                For Insurance Company use Only
              </Text>
              <Text style={styles.s1textvalue}>
                {printData?.preauth_status === "approved" ? (
                  <> {"  "}Approved (✓) Not Approved ( )</>
                ) : (
                  <>Approved ( ) Not Approved (✓)</>
                )}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval No: {"  "}</Text>
              <Text style={styles.s1textvalue}>
                {preauthResponse?.preauth_ref || ""}
              </Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Approval validity </Text>
              <Text style={styles.s1textvalue}>{days}</Text>
            </Text>
          </View>
          <Text style={styles.s1textvalue}>
            Comments (include approved days/services if different from the
            requested)
          </Text>
          <Text style={[styles.s1textvalue, { paddingTop: 5 }]}>
            {"."?.repeat(100)}
          </Text>
          <View style={styles.flexRow}>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>
                Approved/Disapproved By {"  "}
              </Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Signature {"  "}</Text>
              <Text style={styles.s1textvalue}>{"."?.repeat(20)}</Text>
            </Text>
            <Text style={styles.dottedLine}>
              <Text style={styles.s1textLabel}>Date: </Text>
              <Text style={styles.s1textvalue}>
                {"."?.repeat(15)}/{"."?.repeat(15)}/{"."?.repeat(15)}
              </Text>
            </Text>
          </View>
        </View>
      </Page>
    </Document>
  );
};

export default PreauthorizationPrintOCAF;

Font.register({
  family: "IBM Plex Sans Arabic",
  src: iBMPlexRegularFont,
});

const styles = StyleSheet.create({
  heading: {
    fontSize: 24,
    textAlign: "center",
    textTransform: "uppercase",
    color: "#000",
    fontWeight: 700,
    marginBottom: 10,
  },
  flexRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 1,
    marginBottom: 1,
  },
  flexColumn: {
    flexDirection: "column",
  },
  cardStyle: {
    padding: "8px 16px",
    border: "2px solid black",
    borderRadius: 15,
    marginTop: 5,
    width: "50%",
  },
  cardDetails: {
    padding: "8px 16px",
    borderRadius: 15,
    marginTop: 0,
  },
  cardStyle1: {
    padding: "8px 16px",
    borderRadius: 15,
    marginTop: 5,
    width: "60%",
  },
  cardStyle2: {
    padding: "8px 16px",
    borderRadius: 15,
    marginTop: 5,
    width: "40%",
  },
  title: {
    fontWeight: 700,
    fontSize: 10,
    color: "#000",
    marginBottom: 5,
  },
  dottedLine: {
    // borderBottom: "1px dashed #5f5f5f",
    marginBottom: 5,
    fontWeight: "bold",
    width: "100%",
    display: "flex",
    alignItems: "center",
    gap: 1,
    color: "#333",
  },
  s1textLabel: {
    fontWeight: "bold",
    // marginRight: 1,
  },
  checkText: {
    fontFamily: "IBM Plex Sans Arabic",
    fontSize: 12,
  },
  s1textvalue: {
    fontWeight: "normal",
    marginRight: 1,
    color: "#1f1e1e",
  },
  mt2: {
    marginTop: 0,
  },
  mt3: {
    marginTop: 5,
  },
  mt4: {
    marginTop: 10,
  },
  page: {
    paddingTop: 20,
    paddingBottom: 30,
    paddingHorizontal: 10,
    fontSize: 9,
    lineHeight: 1.6,
    backgroundColor: "#fff",
    textTransform: "capitalize",
    fontFamily: "IBM Plex Sans Arabic",
  },

  card: {
    border: "2px solid #000",
    borderRadius: 15,
    padding: 5,
    marginTop: 5,
    marginBottom: 5,
  },
  emergencyCasStyle: {
    flexDirection: "row",
    justifyContent: "space-between",
    border: "1px solid #000",
    borderRadius: 15,
    padding: 1,
    padding: 5,
    width: "70%",
    fontSize: 10,
    paddingRight: 1,
  },
  checkItem: {
    flexDirection: "row",
    alignItems: "center",
    fontSize: 10,
    paddingRight: 5,
  },
  textLabel: {
    fontSize: 10,
    fontWeight: "normal",
    marginRight: 2,
  },
  table: {
    display: "table",
    width: "auto",
    marginTop: 5,
    borderCollapse: "collapse", // Add this for better border handling
  },
  tableCell: {
    borderTop: "0.7px solid #999",
    borderLeft: "0.7px solid #999",
    padding: 0,
    textAlign: "center",
    fontSize: 10,
    width: "15%",
    // Remove right and bottom borders from individual cells
  },
  descriptionCell: {
    width: "40%",
  },
  descriptionCell1: {
    width: "55%",
  },
  // Add a new style for the last cell in row
  lastTableCell: {
    borderRight: "0.7px solid #999",
  },
  lastRowBorder: {
    borderBottomWidth: 1,
    borderColor: "#999", // or any color you use for table lines
  },

  tableCellSer: {
    borderTop: "0.7px solid #999",
    borderLeft: "0.7px solid #999",
    padding: 1,
    textAlign: "center",
    fontSize: 8,
    width: "10%",
  },
  noDataCell: {
    width: "100%",
    textAlign: "center",
    padding: 10,
    borderBottom: "0.7px solid #999",
    borderLeft: "0.7px solid #999",
    borderRight: "0.7px solid #999",
  },
  lastTableCellSer: {
    borderRight: "0.7px solid #999",
    width: "10%",
  },
  descriptionCellSer: {
    width: "30%",
  },
  tableCell1: {
    borderTop: "0.7px solid #999",
    borderLeft: "0.7px solid #999",
    padding: 5,
    textAlign: "center",
    fontSize: 10,
    width: "20%",
    // Remove right and bottom borders from individual cells
  },
  descriptionCell1: {
    width: "60%",
  },
  // Add a new style for the last cell in row
  lastTableCell1: {
    borderRight: "0.7px solid #999",
  },

  tableRow: {
    flexDirection: "row",
  },

  labelRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    paddingBottom: 5,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginTop: 10,
  },
  text: {
    marginBottom: 10,
    fontSize: 9,
    lineHeight: 1.3,
  },
  signatureSection: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginTop: 10,
  },
  line: {
    width: 100,
    borderBottomWidth: 1,
    borderColor: "#000",
  },

  insSec: {
    marginTop: 10,
    padding: 10,
    borderWidth: 1,
    borderColor: "#000",
    borderRadius: 5,
  },
  insRow: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 5,
  },
  checkboxGroup: {
    flexDirection: "row",
    alignItems: "center",
  },
  checkbox: {
    width: 10,
    height: 10,
    borderWidth: 1,
    borderColor: "#000",
    marginRight: 5,
  },
  commentLine: {
    marginTop: 0,
    borderBottomWidth: 1,
    borderColor: "#b5b5b5",
  },
  footer: {
    left: 0,
    right: 0,
    bottom: 0,
    padding: 24,
    margin: "auto",
    borderTopWidth: 1,
    borderStyle: "solid",
    position: "absolute",
    borderColor: "#DFE3E8",
  },
  pageNumber: {
    position: "absolute",
    fontSize: 8,
    bottom: 5,
    right: 10,
    textAlign: "right",
    color: "#a4a4a4",
  },
  createdBy: {
    position: "absolute",
    fontSize: 8,
    bottom: 5,
    left: 10,
    textAlign: "left",
    color: "#a4a4a4",
  },
  superscript: {
    fontSize: 10,
    marginBottom: 5,
    textTransform: "lowercase",
    textAlignVertical: "top", // Move up like superscript
  },
  gridContainer: {
    display: "grid",
    gridTemplateColumns: "repeat(12, 1fr)",
    gridTemplateRows: "repeat(4, 1fr)",
    gridColumnGap: 1,
    gridRowGap: 1,
  },
  checkBox: {
    width: "20px",
    height: "20px",
    borderRadius: "5px",
    border: "1px solid #000",
    // backgroundColor: "#666",
  },
  roundedBorder: {
    borderLeft: "1px solid #ccc", // outer border
    borderTop: "1px solid #ccc",
  },
  cell: {
    borderRight: "1px solid #ccc",
    borderBottom: "1px solid #ccc",
    padding: "4px",
    textAlign: "center",
    // display: "flex",
    // justifyContent: "center",
    // alignItems: "center",
  },
  cell0: {
    gridColumn: "span 2 / span 2",
    gridColumnStart: 1,
    gridRowStart: 1,
  },
  cell1: {
    gridColumn: "span 10 / span 10",
    gridColumnStart: 3,
    gridRowStart: 1,
  },
  cell2: { gridArea: "2 / 3 / 3 / 6" },
  cell3: { gridArea: "2 / 6 / 3 / 9" },
  cell4: { gridArea: "2 / 9 / 3 / 10" },
  cell5: { gridArea: "2 / 10 / 3 / 12" },
  cell6: { gridArea: "2 / 12 / 3 / 13" },
  cell7: { gridArea: "3 / 1 / 4 / 3" },
  cell8: { gridArea: "3 / 3 / 4 / 6" },
  cell9: { gridArea: "3 / 6 / 4 / 9" },
  cell10: { gridArea: "3 / 9 / 4 / 10" },
  cell11: { gridArea: "3 / 10 / 4 / 12" },
  cell12: { gridArea: "3 / 12 / 4 / 13" },
  cell13: { gridArea: "4 / 1 / 5 / 3" },
  cell14: { gridArea: "4 / 3 / 5 / 6" },
  cell15: { gridArea: "4 / 6 / 5 / 9" },
  cell16: { gridArea: "4 / 9 / 5 / 10" },
  cell17: { gridArea: "4 / 10 / 5 / 12" },
  cell18: { gridArea: "4 / 12 / 5 / 13" },

  cell11: { gridArea: "1 / 3 / 2 / 12" },
  cell22: { gridArea: "1 / 12 / 3 / 13" },
  cell33: { gridArea: "2 / 3 / 3 / 6" },
  cell44: { gridArea: "2 / 6 / 3 / 9" },
  cell55: { gridArea: "2 / 9 / 3 / 10" },
  cell66: { gridArea: "2 / 10 / 3 / 11" },
  cell77: { gridArea: "2 / 11 / 3 / 12" },
  cell88: { gridArea: "3 / 1 / 4 / 3" },
  cell99: { gridArea: "3 / 3 / 4 / 6" },
  cell100: { gridArea: "3 / 6 / 4 / 9" },
  cell111: { gridArea: "3 / 9 / 4 / 10" },
  cell122: { gridArea: "3 / 10 / 4 / 11" },
  cell133: { gridArea: "3 / 11 / 4 / 12" },
  cell144: { gridArea: "3 / 12 / 4 / 13" },
  cell155: { gridArea: "4 / 1 / 5 / 3" },
  cell166: { gridArea: "4 / 3 / 5 / 6" },
  cell177: { gridArea: "4 / 6 / 5 / 9" },
  cell188: { gridArea: "4 / 9 / 5 / 10" },
  cell199: { gridArea: "4 / 10 / 5 / 11" },
  cell200: { gridArea: "4 / 11 / 5 / 12" },
  cell211: { gridArea: "4 / 12 / 5 / 13" },
});
